import { Fetcher } from '../../lib/helpers';

const parseLandingExploreThumbnails = tiles => {
  const exploreThumbnails = [];
  for (let i = 0; i < tiles.length; i++) {
    if (exploreThumbnails.length === 3) {
      return exploreThumbnails;
    }
    if (tiles[i].thumbnailContentType !== 'image/gif') {
      exploreThumbnails.push(tiles[i].thumbnail);
    }
  }
  return exploreThumbnails;
};

const AudienceApi = {};

AudienceApi.sanitizeAudienceResponse = resp => ({
  id: resp.id,
  name: resp.name,
  thumbnails: parseLandingExploreThumbnails(resp.tiles),
  description: resp.description,
  ongoing: resp.ongoing,
  copyText: 'Copy Campaign',
  path: `audiences/${resp.id}-${resp.name
    .toLowerCase()
    .replace(/[^A-Za-z0-9 ]/g, '')
    .replace(/\s+/g, '-')}`,
});

AudienceApi.getAll = (currentBoard, respFn) => {
  Fetcher.get(
    `/api/client_admin/explore/audiences?demo=${currentBoard}`,
    respFn,
  );
};

AudienceApi.findBy = (audiences, key, value) => {
  for (let i = 0; i < audiences.length; i++) {
    if (`${audiences[i][key]}` === value) {
      return audiences[i];
    }
  }
  return false;
};

export default AudienceApi;
